module.exports = __webpack_public_path__ + "img/barraFondo2.52596bf3.svg";